module.exports = __webpack_public_path__ + "img/medicamentos.4d389b5e.png";